import { TemplateFormFactory } from '../../../../../template-form/factories/templateFormFactory';
import {
  FlatFileObjectConfigFormRawTemplate,
  FlatFileObjectConfigFormTemplate
} from '../interfaces/flat-file-object-config-form-template';

export const DUMMY_OBJECT_ID = 'DUMMY_OBJECT_ID';

export function FlatFileObjectConfigFormFactory(
  rawTemplate: FlatFileObjectConfigFormRawTemplate
): FlatFileObjectConfigFormTemplate {
  const flatFileObjectConfigFormTemplate: FlatFileObjectConfigFormTemplate = {
    ...TemplateFormFactory(rawTemplate, 'CREATE'),
    sourceObjectsFormValuesMap: rawTemplate.source_object_id_to_form_values
  };

  if (Object.keys(rawTemplate.source_object_id_to_form_values).length === 0) {
    return {
      ...flatFileObjectConfigFormTemplate,
      sourceObjectsFormValuesMap: { [DUMMY_OBJECT_ID]: {} }
    };
  }

  return flatFileObjectConfigFormTemplate;
}
